import React, {useContext, useState} from 'react';
import {Row, Col, Form, InputGroup, Button, Spinner} from 'react-bootstrap';
import styles from './modal-content-invite-investor.module.scss'
import Loading from "../../../../../components/loading/loading";
import UserService from "../../../../../services/user-service";
import {SecurityContext} from "../../../../../context/security-context";
import checkIcon from '../../../../../assets/orders-table-accept.svg'
import failIcon from '../../../../../assets/orders-table-reject.svg';
import {INVITE_INVESTOR_INVALID_EMAIL, INVITE_INVESTOR_SUCCESS} from "../../../../../helpr/constants";
import {isValidEmail} from "../../../../../helpr/helper";

const InviteInvestorModalContent = () => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState({msg:'', show: false});
  const [errorMessage, setErrorMessage] = useState({msg:'', show: false});
  const [email, setEmail] = useState('');
  const { securityState } = useContext(SecurityContext);
  const userService = new UserService();

  const onFieldChange = (e) => {
    setEmail(e.target.value);
  }

  const invite = async () => {
    setLoading(true)
    const trimmed_email = email.trim();
    try{
      if(trimmed_email === '' || !isValidEmail(trimmed_email)){
        throw new Error(INVITE_INVESTOR_INVALID_EMAIL);
      }

      await userService.registerUserAccess(trimmed_email, securityState)
      setLoading(false);
      showSuccessMessage(INVITE_INVESTOR_SUCCESS);
    } catch (error) {
      setLoading(false);
      showErrorMessage(error.message)
      console.log(error.message);
    } finally {
      setEmail('');
    }
  }

  const showSuccessMessage = (msg) => {
    setSuccessMessage({
      ...successMessage,
      msg,
      show: true
    });
    setTimeout(()=>setSuccessMessage({...successMessage, show: false}), 3600);
  }

  const showErrorMessage = (msg) => {
    setErrorMessage({
      ...errorMessage,
      msg,
      show: true
    });
    setTimeout(()=>setErrorMessage({...errorMessage, show: false}), 3600);
  }

  return (
    <div className={styles['content']}>
      <Row>
        <Col lg={12}>
          <InputGroup size="sm">
            <Form.Control type="text" placeholder="Enter Email Address" value={email} onChange={onFieldChange} />
            <InputGroup.Append >
              <Button onClick={() => invite()}>
                Add
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        {loading ? <Loading/> : ''}
        {successMessage.show
          ? <div className={styles['success-msg']}>
              <img alt="Success" src={checkIcon} />{' '}{successMessage.msg}
            </div>
          : ''}
        {errorMessage.show
          ? <div className={styles['error-msg']}>
            <img alt="Fail" src={failIcon} />{' '}{errorMessage.msg}
          </div>
          : ''}
      </Row>
    </div>
  );
}

export default InviteInvestorModalContent;

